import FieldPanelContent from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Sidebars/DocumentPanelSidebar/FieldPanel/FieldPanelContent';
import type * as React from 'react';
import { useSelector } from '@verclam/synapse';

type Props = {
	/** Dixit opaque key of the field (`DocumentFieldView.key`). */
	readonly fieldKey: string;
	/** Occurrence the click came from (`ViewerOccurrence.key`), `null` when opened from Dixit. */
	readonly occurrenceKey: string | null;
};

/**
 * The content of the sidebar for a field: value and its control, sources, review trace, hints,
 * messages and actions. Renders nothing for an unknown key — the shell then shows the "gone" panel.
 */
const FieldPanel: React.FC<Props> = ({ fieldKey }) => {
	const document = useSelector((state) => state.documentsStore.document);
	const field = document?.findFieldByKey(fieldKey) ?? null;

	if (field === null) {
		return null;
	}

	return <FieldPanelContent key={field.key} field={field} />;
};

export default FieldPanel;
